import { render } from "./AddressAutoCompleteKleberNew.vue?vue&type=template&id=2b6a403b&scoped=true"
import script from "./AddressAutoCompleteKleberNew.vue?vue&type=script&lang=js"
export * from "./AddressAutoCompleteKleberNew.vue?vue&type=script&lang=js"

import "./AddressAutoCompleteKleberNew.vue?vue&type=style&index=0&id=2b6a403b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6a403b"]])

export default __exports__